import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ErrorBoundary } from './components/ErrorBoundary';
import Home from './pages/Home';

/* Home ships in the entry chunk (it is the common landing route); every other
   route is split so a first paint never downloads the whole site. */
const HowItWorks = lazy(() => import('./pages/HowItWorks'));
const Report = lazy(() => import('./pages/Report'));
const EvidenceStandard = lazy(() => import('./pages/EvidenceStandard'));
const EngineAttestation = lazy(() => import('./pages/EngineAttestation'));
const Pricing = lazy(() => import('./pages/Pricing'));
const Faq = lazy(() => import('./pages/Faq'));
const Contact = lazy(() => import('./pages/Contact'));
const NotFound = lazy(() => import('./pages/NotFound'));

function RouteFallback() {
  return (
    <div role="status" aria-live="polite" className="tone-aurora siv-panel mb-4 px-6 py-24">
      <p className="eyebrow text-muted">Loading…</p>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route
            path="how-it-works"
            element={
              <Suspense fallback={<RouteFallback />}>
                <HowItWorks />
              </Suspense>
            }
          />
          <Route
            path="report"
            element={
              <Suspense fallback={<RouteFallback />}>
                <Report />
              </Suspense>
            }
          />
          <Route
            path="evidence-standard"
            element={
              <Suspense fallback={<RouteFallback />}>
                <EvidenceStandard />
              </Suspense>
            }
          />
          <Route
            path="engine"
            element={
              <Suspense fallback={<RouteFallback />}>
                <EngineAttestation />
              </Suspense>
            }
          />
          <Route
            path="pricing"
            element={
              <Suspense fallback={<RouteFallback />}>
                <Pricing />
              </Suspense>
            }
          />
          <Route
            path="faq"
            element={
              <Suspense fallback={<RouteFallback />}>
                <Faq />
              </Suspense>
            }
          />
          <Route
            path="contact"
            element={
              <Suspense fallback={<RouteFallback />}>
                <Contact />
              </Suspense>
            }
          />
          <Route
            path="*"
            element={
              <Suspense fallback={<RouteFallback />}>
                <NotFound />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
